import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'indicatif',
    standalone: false
})
export class IndicatifPipe implements PipeTransform {
    transform(indicatifs: number[]): string {
        if (indicatifs == null || indicatifs.length < 1) {
            return '';
        }
        return '(+' + indicatifs.join(', +') + ') - ';
    }
}
